import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import { dateFormate } from "../../config/config";
import { apiService } from "../../service/api.service";

const BannerReport = () => {
    const [loader, setLoader] = useState(false);
    const [filterOptions, setFilterOptions] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("all");
    const [reportList, setReportList] = useState([]);
    const [reportTotal, setReportTotal] = useState(0);
    const [reportPage, setReportPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        fetchBannerFilters();
    }, []);

    useEffect(() => {
        fetchBannerReports(reportPage, selectedFilter);
    }, [reportPage, selectedFilter]);

    const fetchBannerFilters = async () => {
        try {
            const response = await apiService.getBannerFilters();
            if (response?.status === 200) {
                const raw = response?.data?.data ?? response?.data ?? [];
                const normalized = Array.isArray(raw)
                    ? raw.map((b) => ({
                        id: b?._id || b?.id || b?.bannerId || b?.banner_id || "",
                        title: b?.title || b?.name || b?.bannerName || b?.banner_name || "Unnamed",
                        enabled: typeof b?.enabled === 'boolean' ? b.enabled : true,
                      }))
                    : [];
                setFilterOptions(normalized.filter((x) => x.id));
            }
        } catch (e) {
            // non-blocking
        }
    };

    const fetchBannerReports = async (pageNumber = 1, filter = "all") => {
        setLoader(true);
        try {
            const response = await apiService.getBannerReports(pageNumber, filter, 10);
            if (response?.status === 200) {
                const raw = response?.data?.data ?? response?.data ?? [];
                setReportList(Array.isArray(raw) ? raw : []);
                setReportTotal(response?.data?.totalRecords || 0);
                setItemsPerPage(response?.data?.perPage || 10);
            }
        } catch (e) {
            // handle in UI if needed
        } finally {
            setLoader(false);
        }
    };

    const handleReportPageChange = (pageNumber) => {
        if (reportPage !== pageNumber) {
            setReportPage(pageNumber);
        }
    };

    return (
        <div className="dashboard-main-area">
            {loader && <ThreeDotSpinner />}
            <Container fluid>
                <div className="dashboard-area-heading management-heading">
                    <Row className="row justify-content-center align-items-center mb-3">
                        <Col md={12} lg={11}>
                            <div className="heading-top-area">
                                <h2 className="align-self-start m-0">Banner Report</h2>
                            </div>
                        </Col>
                    </Row>

                    <Row className="pb-4 justify-content-center">
                        <Col md={12} lg={11}>
                            <div className="d-flex gap-3 mb-3">
                                <div style={{ minWidth: 260 }}>
                                    <Form.Label>Filter by Banner</Form.Label>
                                    <Form.Select
                                        value={selectedFilter}
                                        onChange={(e)=>{ setSelectedFilter(e.target.value); setReportPage(1); }}
                                    >
                                        <option value="all">All</option>
                                        {filterOptions?.map((b)=> (
                                            <option key={b.id} value={b.id}>{`${b.title} (${b.enabled ? 'Enabled' : 'Disabled'})`}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            <div className="audit-request-box">
                                <Table responsive="sm" className="UserListTable">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Banner ID</th>
                                            <th>Banner Name</th>
                                            <th>User ID</th>
                                            <th>Wallet Address</th>
                                            <th>Email</th>
                                            <th>Created At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportTotal != null && reportTotal > 0 && reportList && reportList.length > 0 ? (
                                            reportList.map((row, idx) => (
                                                <tr key={row._id || idx}>
                                                    <td>{(reportPage - 1) * itemsPerPage + idx + 1}</td>
                                                    <td>{row?.bannerId?._id || row?.banner_id || "-"}</td>
                                                    <td>{row?.bannerId?.title || row?.bannerName || row?.banner_name || "-"}</td>
                                                    <td>{row?.userId || row?.user_id || "-"}</td>
                                                    <td style={{maxWidth: '220px', wordBreak: 'break-all'}}>{row?.walletAddress || row?.wallet_address || "-"}</td>
                                                    <td>{row?.userEmail || row?.email || "-"}</td>
                                                    <td>{row?.createdAt ? moment(row.createdAt).format(dateFormate) : "-"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className="no-dat-found-box">
                                                <td colSpan={7}>
                                                    <img
                                                        src={require("../../assets/images/no-data.svg").default}
                                                        alt="da"
                                                    />
                                                    <h3 className="text-center text-light">No data found</h3>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>

                                {reportTotal && reportTotal > 0 ? (
                                    <Pagination
                                        activePage={reportPage}
                                        itemsCountPerPage={itemsPerPage}
                                        totalItemsCount={reportTotal}
                                        pageRangeDisplayed={5}
                                        onChange={(e)=> handleReportPageChange(e)}
                                        prevPageText={"Prev"}
                                        nextPageText={"Next"}
                                    />
                                ) : null}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default BannerReport;


